var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMadFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0v45h60V0Z",
    fill: "#C1272D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m30 15.043 1.677 5.165h5.413l-4.38 3.177 1.67 5.142L30 25.35l-4.38 3.177 1.67-5.142-4.38-3.177h5.412L30 15.044Zm-2.034 6.262H26.29l1.357.983.32-.983Zm.614 1.66.54-1.66h1.76l.54 1.66-1.42 1.03-1.42-1.03Zm-.356 1.097-.52 1.598 1.362-.987-.842-.61Zm2.71.611 1.361.987-.519-1.598-.842.611Zm1.42-2.384 1.356-.984h-1.676l.32.983Zm-1.83-2.081h-1.048L30 18.594l.524 1.614Z",
    fill: "#006233"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadFlag);
export default __webpack_public_path__ + "static/media/mad-flag.e93f3ac8186a7b865060b32a9a32ab13.svg";
export { ForwardRef as ReactComponent };